<script>
import { prettyPrintFileSize } from "../../js/helper";

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    maxFiles: {
      type: Number,
      required: false
    },
    accept: {
      type: String,
      default: "*"
    },
    maxSize: {
      type: Number,
      default: 5 * 1024 * 1024
    },
    cropper: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dragging: false,
      files: []
    };
  },
  methods: {
    openFileDialog() {
      this.$refs.fileInput.click();
    },
    validateFiles(files) {
      if (this.cropper) return true;
      if (files.some(file => file.size > this.maxSize)) {
        this.$toast.error(
          this.$t("errors.fileSizeExceeded", {
            size: prettyPrintFileSize(this.maxSize)
          }),
          {
            duration: 8000
          }
        );
        return false;
      }
      if (!this.multiple && files.length > 1) {
        this.$toast.error(this.$t("errors.singleFileOnly"), {
          duration: 8000
        });
        return false;
      }
      if (this.maxFiles && files.length > this.maxFiles) {
        this.$toast.error(
          this.$t("errors.tooManyFiles", { max: this.maxFiles }),
          { duration: 8000 }
        );
        return false;
      }
      return true;
    },

    onInputChange(e) {
      const files = Array.from(e.target.files || []);
      if (files.length === 0) return;
      if (!this.validateFiles(files)) return;
      this.emitFiles(files);
      e.target.value = "";
    },
    onDrop(e) {
      this.dragging = false;
      const dtFiles =
        e.dataTransfer && e.dataTransfer.files
          ? Array.from(e.dataTransfer.files)
          : [];

      if (dtFiles.length === 0) return;
      if (!this.validateFiles(dtFiles)) return;
      this.emitFiles(dtFiles);
    },
    emitFiles(files) {
      // emit a plain array of File objects
      this.$emit("change", files);
    },
    onDragOver(e) {
      e.preventDefault();
      this.dragging = true;
    },
    onDragLeave(e) {
      this.dragging = false;
    },
    onKeydown(e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        this.openFileDialog();
      }
    },
    prettyPrintFileSize
  }
};
</script>
<template>
  <div
    class="file-input-wrap"
    :class="{ dragging }"
    @click="openFileDialog"
    @dragover.prevent="onDragOver"
    @dragenter.prevent="onDragOver"
    @dragleave.prevent="onDragLeave"
    @drop.prevent="onDrop"
    tabindex="0"
    @keydown="onKeydown"
  >
    <input
      ref="fileInput"
      type="file"
      class="hidden"
      :multiple="multiple"
      :accept="accept"
      @change="onInputChange"
    />
    <img src="@/assets/newImges/file-input/cloud.png" alt="" />
    <div>
      <span>
        {{ $t("main.fileInputText") }}
      </span>
      <br />
      <span>{{
        $t("main.maxFileSize", { size: prettyPrintFileSize(maxSize) })
      }}</span>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.file-input-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px dashed $gray-blue-1300;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 16px;
  cursor: pointer;
  padding: 30px 20px;
  box-sizing: border-box;
  text-align: left;
  gap: 10px;
  color: $gray-blue-1300;
  outline: none;
  &.dragging {
    transition: all 0.2s ease-in-out;
    transform: scale(1.02);
    border-color: $light-blue-500;
    color: $light-blue-500;
    // background: rgba(0, 0, 0, 0.02);
  }
  .hidden {
    display: none;
  }
}
</style>
